import styled from "styled-components";

export const DailyDealTextStripBox = styled.span`
    background: url(${({theme}) => theme.images.dailyDeal.textStrip.toString()}) center no-repeat;
    background-size: cover;
    
    display: block;
    
    width: 120px;
    height: 30px;
    
    color: ${({theme}) => theme.colors.textLight};
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    
    padding: 2.5px 10px 0;
    text-align: center;
    font-size: 13px;
    line-height: 19px;    
}
`;
